import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';

export const ClearUserSearchOptions = createAction(
  '[User Management: Search]: Clear User Search Options',
);

export const GetSecGroups = createAction('[User Management: Search]: Get Security Groups');

export const GetSecGroupsSuccess = createAction(
  '[User Management: Search]: Get Security Groups Success',
  props<{ res: any }>(),
);

export const GetSecGroupsFailed = createAction(
  '[User Management: Search]: Get Security Groups Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const GetSecGroup = createAction(
  '[User Management: Search]: Get Security Group',
  props<{ secGroupId: string | number }>(),
);

export const GetSecGroupSuccess = createAction(
  '[User Management: Search]: Get Security Group Success',
  props<{ res: any }>(),
);

export const GetSecGroupFailed = createAction(
  '[User Management: Search]: Get Security Group Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const GetBusinessGroups = createAction('[User Management: Search]: Get Business Groups');

export const GetBusinessGroupsSuccess = createAction(
  '[User Management: Search]: Get Business Groups Success',
  props<{ res: any }>(),
);

export const GetBusinessGroupsFailed = createAction(
  '[User Management: Search]: Get Business Groups Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const GetAvailableLanguages = createAction(
  '[User Management: Search]: Get Available Languages',
);

export const GetAvailableLanguagesSuccess = createAction(
  '[User Management: Search]: Get Available Languages Success',
  props<{ res: any }>(),
);

export const GetAvailableLanguagesFailed = createAction(
  '[User Management: Search]: Get Available Languages Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const GetCountries = createAction('[User Management: Search]: Get Countries');

export const GetCountriesSuccess = createAction(
  '[User Management: Search]: Get Countries Success',
  props<{ res: any }>(),
);

export const GetCountriesFailed = createAction(
  '[User Management: Search]: Get Countries Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const GetPolicyDocuments = createAction('[User Management: Search]: Get Policy Documents');

export const GetPolicyDocumentsSuccess = createAction(
  '[User Management: Search]: Get Policy Documents Success',
  props<{ res: any }>(),
);

export const GetPolicyDocumentsFailed = createAction(
  '[User Management: Search]: Get Policy Documents Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const PanelStatusChanged = createAction('[User Management: Search]: Panel Status Changed');

export const UserNameChanged = createAction(
  '[User Management: Search]: User Name Changed',
  props<{ userName: string }>(),
);

export const DisplayedNameChanged = createAction(
  '[User Management: Search]: Displayed Name Changed',
  props<{ displayedName: string }>(),
);

export const EmailChanged = createAction(
  '[User Management: Search]: Email Changed',
  props<{ email: string }>(),
);

export const SecurityGroupChanged = createAction(
  '[User Management: Search]: Security Group Changed',
  props<{ securityGroup: string }>(),
);

export const BusinessGroupChanged = createAction(
  '[User Management: Search]: Business Group Changed',
  props<{ businessGroup: string }>(),
);

export const DeactivatedChanged = createAction('[User Management: Search]: Deactivated Changed');

export const QuicksightChanged = createAction('[User Management: Search]: Quicksight Changed');

export const ClearSearchOptions = createAction('[User Management: Search]: Clear Search Options');

export const UserSearchCount = createAction('[User Management: Search]: User Search Count');

export const UserSearchCountFailed = createAction(
  '[User Management: Search]: User Search Count Failed',
  props<{ error: HttpErrorResponse }>(),
);
